import { useEffect, useState } from "react";
import { useLang } from "../i18n";
import api from "../lib/api";
import { CalendarClock, ShieldAlert } from "lucide-react";

const impactColor = { HIGH: "#EF4444", MEDIUM: "#F59E0B", LOW: "#3B82F6" };

export default function NewsPanel() {
  const { t } = useLang();
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/news").then((r) => setEvents(r.data.events)).catch(() => {}); }, []);

  return (
    <div className="border border-[#1E2028] bg-[#0F1015]">
      <div className="flex items-center gap-2 p-4 border-b border-[#1E2028] text-sm font-display font-bold">
        <CalendarClock className="w-4 h-4 text-[#FACC15]" /> {t("upcomingEvents")}
      </div>
      <div className="divide-y divide-[#1E2028]">
        {events.map((e, i) => (
          <div key={i} data-testid="news-event" className="flex items-center gap-3 p-4 hover:bg-[#17181F] transition-colors duration-200">
            <span className="w-14 shrink-0 text-xs font-mono text-[#9CA3AF]">{e.time}</span>
            <span className="px-2 py-0.5 text-[10px] font-bold font-mono" style={{ color: impactColor[e.impact], background: `${impactColor[e.impact]}22` }}>{e.impact}</span>
            <span className="px-1.5 py-0.5 text-[10px] font-mono border border-[#1E2028] text-[#9CA3AF]">{e.currency}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-white truncate">{e.title}</div>
              {e.impact === "HIGH" && (
                <div className="flex items-center gap-1 text-[10px] text-[#F59E0B] font-mono mt-0.5">
                  <ShieldAlert className="w-3 h-3" /> {e.guardian_action}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
